"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inscription = void 0;
const client_1 = require("./client");
class Inscription {
    constructor(key = "", environment = "live") {
        if (this.instance !== undefined) {
            console.error("inscription.setCredentials was called multiple times");
            return;
        }
        this.instance = new client_1.InscriptionClient(key, environment);
    }
    getPrice(priceRequest) {
        return this.instance.getPrice(priceRequest);
    }
    createOrder(order) {
        return this.instance.createOrder(order);
    }
    getOrder(id) {
        return this.instance.getOrder(id);
    }
    createCollection(collection) {
        return this.instance.createCollection(collection);
    }
    createCollectionOrder(collectionOrder) {
        return this.instance.createCollectionOrder(collectionOrder);
    }
    createTextOrder(order) {
        return this.instance.createTextOrder(order);
    }
    getInventory() {
        return this.instance.getInventory();
    }
    setReferralCode(referral) {
        return this.instance.setReferralCode(referral);
    }
    getReferralStatus(referral) {
        return this.instance.getReferralStatus(referral);
    }
}
exports.Inscription = Inscription;
//# sourceMappingURL=inscription.js.map